var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "5",
      "order-lg": "2"
    }
  }, [_c('v-img', {
    staticClass: "firm-image",
    attrs: {
      "data-aos": "fade",
      "data-aos-duration": "800",
      "max-height": _vm.$vuetify.breakpoint.lgAndUp ? '' : '240',
      "src": "/images/sub/firm/firm-img.jpg",
      "alt": ""
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "7",
      "order-lg": "1"
    }
  }, [_c('v-sheet', {
    staticClass: "d-flex flex-column justify-space-between",
    attrs: {
      "color": "transparent",
      "max-width": "648",
      "height": "100%",
      "data-aos": "fade-right",
      "data-aos-duration": "700"
    }
  }, [_c('div', {
    staticClass: "txt break-keep"
  }, [_vm.lang === 'ko' ? [_c('p', [_vm._v(" 세이지(SAGE)라는 이름에는 ‘지혜롭고 신뢰할 수 있는 동반자’로서, "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 끊임없는 변화와 도전 속에서도 깊은 통찰과 전문성을 바탕으로 고객의 가치를 지키겠다는 저희의 다짐이 담겨 있습니다. ")]), _c('br'), _c('p', [_vm._v("세이지는 기업자문과 M&A, 그리고 국내외 소송 등 분쟁 해결 분야에 특화된 법무법인입니다. 저희는 모든 법률 분야를 다 잘할 수는 없다는 사실을 잘 알고 있습니다. 그러나 저희가 잘하는 분야에서는, 누구보다 깊이 있게 고민하고, 누구보다 정교하게 실행함으로써 고객들로부터 최고의 실력과 로열티를 인정받고 있습니다.")]), _c('br'), _c('p', [_vm._v(" 저희는 파트너 변호사들이 직접 실무를 이끄는 효율적인 팀 구성(lean team)을 통해 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 불필요한 비용을 줄이고, 현실적인 해법을 제시하는 실용적 조언(practical solution), "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 그리고 고객이 진정으로 원하는 결과(desired result)에 도달하는 것을 핵심 가치로 삼아 꾸준히 실천해 왔습니다. ")]), _c('br'), _c('p', [_vm._v("저희에게 주저없이 연락 주시면 최고의 실력과 정성으로 보답하겠습니다.")])] : [_c('p', [_vm._v("The name "), _c('strong', [_vm._v("SAGE")]), _vm._v(" embodies our commitment to serving as a “wise and trustworthy companion.” Guided by insight and expertise, we are dedicated to safeguarding our clients’ value in an environment of constant change and challenge.")]), _c('br'), _c('p', [_vm._v("SAGE specializes in M&A/corporate advisory and domestic/international dispute resolution. We know that no firm can claim strength in all areas of law, but in the fields where we do excel, we are recognized for our depth of analysis, precision of execution, and the trust and loyalty we earn from our clients through exceptional results.")]), _c('br'), _c('p', [_vm._v("Our lean teams, led directly by partners, allow us to minimize unnecessary costs while staying focused on what matters most: delivering practical solutions, providing clear and actionable advice, and achieving the results most desired by our clients.")])]], 2), _c('img', {
    staticClass: "d-block mt-40px",
    attrs: {
      "src": "/images/sub/firm/firm-logo.svg",
      "alt": ""
    }
  })])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }